/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPrinterStatus = 'Ok' | 'Offline' | 'NotOpen';

export const EPrinterStatus = {
    Ok: 'Ok' as EPrinterStatus,
    Offline: 'Offline' as EPrinterStatus,
    NotOpen: 'NotOpen' as EPrinterStatus
};

